


































import Vue from 'vue'
import { RepairStatusElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'RepairStatusEl',
  props: {
    templateItemData: {
      type: Object as () => RepairStatusElInterface,
      required: true
    }
  }
})
